import { render, staticRenderFns } from "./episode-detail.vue?vue&type=template&id=3557e824&scoped=true&"
import script from "./episode-detail.vue?vue&type=script&lang=js&"
export * from "./episode-detail.vue?vue&type=script&lang=js&"
import style0 from "./episode-detail.vue?vue&type=style&index=0&id=3557e824&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557e824",
  null
  
)

export default component.exports